import { defineComponent as _defineComponent } from 'vue'
import { first } from "lodash";

import TtStakeReportByNumCount from "@/components/modules/report/TtStakeReportByNumCount.vue";
import { computed } from "vue";
import { useRoute } from "vue-router/composables";
import { useTranslation } from "@/store/translation";


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyStakeReportLegacy',
  setup(__props) {

const { $t } = useTranslation();
const route = useRoute()

const selectedStartReleaseDate = computed(() => {
  const query = route.query.startReleaseDate;
  return Array.isArray(query) ? first(query) : query;
})


const selectedEndReleaseDate = computed(() => {

  const query = route.query.endReleaseDate;
  return Array.isArray(query) ? first(query) : query;
})




return { __sfc: true,$t, route, selectedStartReleaseDate, selectedEndReleaseDate, TtStakeReportByNumCount }
}

})